interface KaptioLogoProps {
  className?: string;
  height?: number;
  variant?: "dark" | "light";
  showDot?: boolean;
  dotColor?: string;
}

export default function KaptioLogo({
  className = "",
  height = 24,
  variant = "light",
  showDot = true,
  dotColor,
}: KaptioLogoProps) {
  const fill = variant === "light" ? "#FFFFFF" : "#034955";
  const width = Math.round(height * (91 / 29));
  const dot = dotColor ?? (variant === "light" ? "#DE37A4" : "#DE37A4");

  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 91 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Kaptio logo"
    >
      <path
        d="M0 0.5H5.2V11.72L14.88 0.5H21.22L11.34 11.78L21.62 28.5H15.22L7.56 15.58L5.2 18.3V28.5H0V0.5Z"
        fill={fill}
      />
      <path
        d="M30.3 28.5C28.7 28.5 27.32 28.18 26.16 27.54C25.02 26.88 24.14 25.96 23.52 24.78C22.92 23.58 22.62 22.18 22.62 20.58V20.34C22.62 18.7 22.94 17.28 23.58 16.08C24.24 14.86 25.14 13.92 26.28 13.26C27.44 12.58 28.78 12.24 30.3 12.24C31.16 12.24 31.92 12.34 32.58 12.54C33.24 12.72 33.84 13 34.38 13.38V12.5H39.34V28.5H34.38V27.56C33.84 27.96 33.24 28.26 32.58 28.46C31.92 28.64 31.16 28.74 30.3 28.74V28.5ZM31.38 24.5C32.38 24.5 33.2 24.14 33.84 23.42C34.5 22.68 34.82 21.72 34.82 20.54V20.38C34.82 19.2 34.5 18.24 33.84 17.52C33.2 16.78 32.38 16.42 31.38 16.42C30.38 16.42 29.54 16.78 28.88 17.52C28.24 18.24 27.92 19.2 27.92 20.38V20.54C27.92 21.72 28.24 22.68 28.88 23.42C29.54 24.14 30.38 24.5 31.38 24.5Z"
        fill={fill}
      />
      <path
        d="M42.18 33.5V12.5H47.14V13.38C47.68 13 48.28 12.72 48.94 12.54C49.6 12.34 50.36 12.24 51.22 12.24C52.74 12.24 54.08 12.58 55.24 13.26C56.4 13.92 57.3 14.86 57.94 16.08C58.58 17.28 58.9 18.7 58.9 20.34V20.58C58.9 22.18 58.58 23.58 57.94 24.78C57.32 25.96 56.44 26.88 55.3 27.54C54.16 28.18 52.78 28.5 51.16 28.5C50.32 28.5 49.58 28.4 48.94 28.2C48.3 28.02 47.7 27.74 47.14 27.36V33.5H42.18ZM50.08 24.5C51.08 24.5 51.92 24.14 52.58 23.42C53.24 22.68 53.58 21.72 53.58 20.54V20.38C53.58 19.2 53.24 18.24 52.58 17.52C51.92 16.78 51.08 16.42 50.08 16.42C49.08 16.42 48.24 16.78 47.58 17.52C46.94 18.24 46.62 19.2 46.62 20.38V20.54C46.62 21.72 46.94 22.68 47.58 23.42C48.24 24.14 49.08 24.5 50.08 24.5Z"
        fill={fill}
      />
      <path
        d="M66.3 28.5C65.1 28.5 64.06 28.26 63.18 27.78C62.3 27.28 61.62 26.56 61.14 25.62C60.66 24.68 60.42 23.54 60.42 22.2V16.5H57.82V12.5H60.42V7.5H65.38V12.5H69.36V16.5H65.38V21.66C65.38 22.5 65.58 23.14 65.96 23.58C66.36 24 66.94 24.22 67.7 24.22H69.36V28.5H66.3Z"
        fill={fill}
      />
      <path d="M71.14 8.5V3.5H76.34V8.5H71.14ZM71.26 28.5V12.5H76.22V28.5H71.26Z" fill={fill} />
      <path
        d="M78.64 20.34C78.64 18.7 78.96 17.28 79.6 16.08C80.24 14.86 81.14 13.92 82.3 13.26C83.46 12.58 84.8 12.24 86.32 12.24C87.84 12.24 89.18 12.58 90.32 13.26C91.48 13.92 92.38 14.86 93.02 16.08C93.68 17.28 94 18.7 94 20.34V20.58C94 22.18 93.68 23.58 93.02 24.78C92.38 25.96 91.48 26.88 90.32 27.54C89.18 28.18 87.84 28.5 86.32 28.5C84.8 28.5 83.46 28.18 82.3 27.54C81.14 26.88 80.24 25.96 79.6 24.78C78.96 23.58 78.64 22.18 78.64 20.58V20.34ZM83.94 20.54C83.94 21.72 84.26 22.68 84.9 23.42C85.56 24.14 86.38 24.5 87.38 24.5C88.38 24.5 89.2 24.14 89.84 23.42C90.5 22.68 90.82 21.72 90.82 20.54V20.38C90.82 19.2 90.5 18.24 89.84 17.52C89.2 16.78 88.38 16.42 87.38 16.42C86.38 16.42 85.56 16.78 84.9 17.52C84.26 18.24 83.94 19.2 83.94 20.38V20.54Z"
        fill={fill}
      />
      {showDot && <circle cx="73.74" cy="3.5" r="3" fill={dot} />}
    </svg>
  );
}
